module.exports = __webpack_public_path__ + "css/Ascot.e177f1c6.css";